
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import VendorList from "@/components/admin/vendors/VendorList";
import VendorAnalytics from "@/components/admin/vendors/VendorAnalytics";
import VendorVerification from "@/components/admin/vendors/VendorVerification";
import VendorPerformance from "@/components/admin/vendors/VendorPerformance";

const VendorManagement = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Vendor Management</h1>
        <p className="text-muted-foreground">
          Comprehensive vendor management system with AI-powered insights
        </p>
      </div>

      <Tabs defaultValue="vendors" className="space-y-4">
        <TabsList>
          <TabsTrigger value="vendors">Vendors</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="verification">Verification</TabsTrigger>
          <TabsTrigger value="performance">Performance</TabsTrigger>
        </TabsList>

        <TabsContent value="vendors" className="space-y-4">
          <VendorList />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-4">
          <VendorAnalytics />
        </TabsContent>

        <TabsContent value="verification" className="space-y-4">
          <VendorVerification />
        </TabsContent>

        <TabsContent value="performance" className="space-y-4">
          <VendorPerformance />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default VendorManagement;
